import { render, staticRenderFns } from "./Tank3DV2.vue?vue&type=template&id=b4ccc99a"
import script from "./Tank3DV2.vue?vue&type=script&lang=js"
export * from "./Tank3DV2.vue?vue&type=script&lang=js"
import style0 from "./Tank3DV2.vue?vue&type=style&index=0&id=b4ccc99a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports